import {Component, Input} from '@angular/core';
import {FormGroup} from '@angular/forms';
import {NumberConfig, ProtocolStatusValues} from '../../../../core/models/entities';
import {SharedUtils} from "../../../services/utils/shared-utils.service";
import {toSignal} from "@angular/core/rxjs-interop";

@Component({
  selector: 'app-protocol-header',
  templateUrl: './protocol-header.component.html',
  styleUrl: './protocol-header.component.scss',
})
export class ProtocolHeaderComponent {

  @Input() item: any;

  @Input() form!: FormGroup;

  @Input() config: NumberConfig | undefined;


  protected readonly protocolStatues = toSignal(SharedUtils.instance().translateOptions(ProtocolStatusValues, 'protocol.default.statuses'));
}
